import type { BreathworkCardChip } from '@breath-lab/domain';
import { benefitNameEn, type TrainingBenefit } from '@breath-lab/types';

export const GOAL_CHIP_LABELS: Record<string, string> = {
  STRESS_RELIEF: 'stress relief',
  BETTER_SLEEP: 'sleep',
  INCREASED_FOCUS_AND_CONCENTRATION: 'focus',
  INCREASED_ENERGY_LEVELS: 'energy',
  CALMS_BODY_AND_MIND: 'calm',
  MOOD_LIFT: 'mood lift',
  EMOTIONAL_BALANCE: 'emotional balance',
};

export function benefitChipLabel(b: TrainingBenefit): string {
  return GOAL_CHIP_LABELS[b.id] ?? benefitNameEn(b).toLowerCase().replace('(hrv)', '(HRV)');
}

export function cardChipLabel(chip: BreathworkCardChip): string {
  if (chip.kind === 'benefit') {
    return GOAL_CHIP_LABELS[chip.id] ?? chip.label.toLowerCase().replace('(hrv)', '(HRV)');
  }
  return chip.label;
}
